<template>
	<div class="relative h-full w-full" ref="target">
		<div class="flex h-full items-center ml-auto">
			<span class="flex flex-col text-right mr-4 ml-auto">
			  <span class="userpilot-mask text-sm font-bold text-black">{{ userName }}</span>
				<Popper hover arrow placement="bottom-start">
					<template #content>
							<div v-html="userOrganizationNameTooltipText"></div>
					</template>

					<span class="text-xs font-bold text-grayscale-body leading-none">{{ userOrganizationNameAndRole }}</span>
				</Popper>
			</span>
			<span class="h-10 w-10 rounded-full flex items-center justify-center p-2 mr-3 cursor-pointer"
					:class="userInitials !== '' ? 'bg-primary text-label-on-color font-semibold hover:bg-primary-bold-hover': 'bg-primary'"
					@click.prevent="dropdownOpen = !dropdownOpen"
					title="User Menu">
				<span class="userpilot-mask ">
					{{ userInitials }}
				</span>
				<svg v-if="userInitials === ''" class="fill-icon-primary-on-color w-8 h-8" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
					<title>User Menu</title>
					<path d="M9.0002 7.79065C11.0814 7.79065 12.7689 6.1594 12.7689 4.1344C12.7689 2.1094 11.0814 0.478149 9.0002 0.478149C6.91895 0.478149 5.23145 2.1094 5.23145 4.1344C5.23145 6.1594 6.91895 7.79065 9.0002 7.79065ZM9.0002 1.7719C10.3783 1.7719 11.5033 2.84065 11.5033 4.16252C11.5033 5.4844 10.3783 6.55315 9.0002 6.55315C7.62207 6.55315 6.49707 5.4844 6.49707 4.16252C6.49707 2.84065 7.62207 1.7719 9.0002 1.7719Z" fill="" />
					<path d="M10.8283 9.05627H7.17207C4.16269 9.05627 1.71582 11.5313 1.71582 14.5406V16.875C1.71582 17.2125 1.99707 17.5219 2.3627 17.5219C2.72832 17.5219 3.00957 17.2407 3.00957 16.875V14.5406C3.00957 12.2344 4.89394 10.3219 7.22832 10.3219H10.8564C13.1627 10.3219 15.0752 12.2063 15.0752 14.5406V16.875C15.0752 17.2125 15.3564 17.5219 15.7221 17.5219C16.0877 17.5219 16.3689 17.2407 16.3689 16.875V14.5406C16.2846 11.5313 13.8377 9.05627 10.8283 9.05627Z" fill="" />
				</svg>
			</span>
		</div>
		<!-- Dropdown Start -->
		<div
			v-show="dropdownOpen"
			class="absolute right-0 flex w-93 sm:w-112 max-h-192 overflow-y-auto flex-col rounded-bl-xl border-x border-t border-neutral bg-neutral shadow-default">
			<ul class="flex flex-col gap-5 border-b border-neutral px-3 py-7.5">
				<li>
					<router-link
						:to="{ name: 'settings.account-settings' }"
						class="flex items-center gap-3.5 font-medium duration-300 ease-in-out hover:text-primary-hover lg:text-base">
						<div class="pl-2.5">
							<svg xmlns="http://www.w3.org/2000/svg" class="fill-current" width="22" height="22" viewBox="0 0 19 19" fill="none">
								<title>Account Settings</title>
								<path d="M17.2269 10.8125L16.0394 10.125C16.0707 9.9375 16.0707 9.71875 16.0707 9.46875C16.0707 9.25 16.0707 9.03125 16.0394 8.8125L17.2269 8.125C18.0394 7.65625 18.3207 6.59375 17.8519 5.78125L16.6332 3.65625C16.4144 3.25 16.0394 2.96875 15.6019 2.875C15.1644 2.75 14.6957 2.8125 14.2894 3.03125L13.1019 3.75C12.7582 3.5 12.3832 3.28125 11.9769 3.09375V1.71875C11.9769 0.78125 11.1957 0 10.2582 0H7.82065C6.88315 0 6.1019 0.78125 6.1019 1.71875V3.09375C5.69565 3.28125 5.32065 3.5 4.9769 3.71875L3.7894 3.03125C3.38315 2.8125 2.94566 2.75 2.47691 2.875C2.03941 3 1.66441 3.28125 1.44566 3.65625L0.226905 5.78125C-0.241845 6.59375 0.0394053 7.65625 0.851905 8.125L2.03941 8.8125C2.00816 9 2.00816 9.21875 2.00816 9.46875C2.00816 9.6875 2.00816 9.90625 2.03941 10.125L0.851905 10.8125C0.0394053 11.2812 -0.241845 12.3437 0.226905 13.1562L1.44566 15.2812C1.66441 15.6875 2.03941 15.9687 2.47691 16.0625C2.91441 16.1875 3.38315 16.125 3.7894 15.9062L4.9769 15.2187C5.32065 15.4687 5.69565 15.6875 6.1019 15.8437V17.2187C6.1019 18.1562 6.88315 18.9375 7.82065 18.9375H10.2582C11.1957 18.9375 11.9769 18.1562 11.9769 17.2187V15.8437C12.3832 15.6562 12.7582 15.4375 13.1019 15.1875L14.2894 15.875C14.6957 16.0937 15.1332 16.1562 15.5707 16.0312C16.0082 15.9062 16.3832 15.625 16.6019 15.25L17.8207 13.125C18.2894 12.3125 18.0082 11.2812 17.2269 10.8125ZM16.6332 12.4375L15.4144 14.5625C15.3832 14.625 15.3207 14.6875 15.2269 14.6875C15.1332 14.7187 15.0707 14.6875 15.0082 14.6562L13.7582 13.9375C13.2894 13.6562 12.7269 13.6875 12.2894 14C12.0082 14.2187 11.6957 14.375 11.3519 14.5312C10.8832 14.75 10.5707 15.2187 10.5707 15.75V17.1875C10.5707 17.3437 10.4457 17.5 10.2582 17.5H7.82065C7.6644 17.5 7.50815 17.375 7.50815 17.1875V15.75C7.50815 15.2187 7.19565 14.75 6.7269 14.5312C6.38315 14.375 6.07065 14.1875 5.7894 14C5.57065 13.8437 5.2894 13.75 5.00815 13.75C4.75815 13.75 4.5394 13.8125 4.3519 13.9375L3.10191 14.6562C3.03941 14.6875 2.94566 14.7187 2.88316 14.6875C2.82066 14.6562 2.75815 14.625 2.69565 14.5625L1.47691 12.4375C1.38316 12.2812 1.44566 12.0937 1.57066 12.0312L2.82066 11.3125C3.25816 11.0625 3.5394 10.5312 3.4769 10.0312C3.44565 9.875 3.44566 9.6875 3.44566 9.5C3.44566 9.28125 3.44565 9.125 3.4769 8.96875C3.5394 8.4375 3.28941 7.9375 2.82066 7.6875L1.57066 6.96875C1.41441 6.875 1.38316 6.6875 1.44566 6.5625L2.66441 4.4375C2.69566 4.375 2.75815 4.3125 2.8519 4.3125C2.94565 4.28125 3.00815 4.3125 3.07065 4.34375L4.32065 5.0625C4.7894 5.34375 5.3519 5.3125 5.7894 5C6.07065 4.78125 6.38315 4.625 6.7269 4.46875C7.19565 4.25 7.50815 3.78125 7.50815 3.25V1.71875C7.50815 1.5625 7.63315 1.40625 7.82065 1.40625H10.2582C10.4144 1.40625 10.5707 1.53125 10.5707 1.71875V3.15625C10.5707 3.6875 10.8832 4.15625 11.3519 4.375C11.6957 4.53125 12.0082 4.71875 12.2894 4.90625C12.7269 5.21875 13.2894 5.25 13.7269 5L14.9769 4.28125C15.0394 4.25 15.1332 4.21875 15.1957 4.25C15.2582 4.28125 15.3207 4.3125 15.3832 4.375L16.6019 6.5C16.6957 6.65625 16.6332 6.84375 16.5082 6.90625L15.2582 7.625C14.8207 7.875 14.5394 8.40625 14.6019 8.90625C14.6332 9.0625 14.6332 9.25 14.6332 9.4375C14.6332 9.65625 14.6332 9.8125 14.6019 9.96875C14.5394 10.5 14.8207 11 15.2582 11.25L16.5082 11.9687C16.6644 12.0937 16.6957 12.2812 16.6332 12.4375Z" fill=""/>
								<path d="M9.03906 5.4375C6.82031 5.4375 5.00781 7.25 5.00781 9.46875C5.00781 11.6875 6.82031 13.5 9.03906 13.5C11.2578 13.5 13.0703 11.6875 13.0703 9.46875C13.0703 7.25 11.2578 5.4375 9.03906 5.4375ZM9.03906 12.0938C7.60156 12.0938 6.41406 10.9062 6.41406 9.46875C6.41406 8.03125 7.60156 6.84375 9.03906 6.84375C10.4766 6.84375 11.6641 8.03125 11.6641 9.46875C11.6641 10.9062 10.4766 12.0938 9.03906 12.0938Z" fill=""/>
								<path d="M9.57031 9.53125V8.65625C9.57031 8.28125 9.25781 7.96875 8.88281 7.96875C8.50781 7.96875 8.19531 8.28125 8.19531 8.65625V9.84375C8.19531 10.0312 8.25781 10.2187 8.41406 10.3437L9.10156 11.0312C9.22656 11.1562 9.41406 11.25 9.60156 11.25C9.78906 11.25 9.97656 11.1875 10.1016 11.0312C10.3828 10.75 10.3828 10.3125 10.1016 10.0312L9.57031 9.53125Z" fill=""/>
							</svg>
						</div>
						Settings
					</router-link>
				</li>
				<li class="divider"/>
<!--				<li v-if="authStore.isAdmin">-->
<!--					<a href="#" @click.prevent="userImpersonation"-->
<!--						class="flex items-center gap-3.5 font-medium duration-300 ease-in-out hover:text-primary-hover lg:text-base"-->
<!--					>-->
<!--						<div class="h-6 w-6 pl-2">-->
<!--							<svg class="fill-current" width="22" height="22" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">-->
<!--								<path-->
<!--									d="M9.0002 7.79065C11.0814 7.79065 12.7689 6.1594 12.7689 4.1344C12.7689 2.1094 11.0814 0.478149 9.0002 0.478149C6.91895 0.478149 5.23145 2.1094 5.23145 4.1344C5.23145 6.1594 6.91895 7.79065 9.0002 7.79065ZM9.0002 1.7719C10.3783 1.7719 11.5033 2.84065 11.5033 4.16252C11.5033 5.4844 10.3783 6.55315 9.0002 6.55315C7.62207 6.55315 6.49707 5.4844 6.49707 4.16252C6.49707 2.84065 7.62207 1.7719 9.0002 1.7719Z"-->
<!--									fill="" />-->
<!--								<path-->
<!--									d="M10.8283 9.05627H7.17207C4.16269 9.05627 1.71582 11.5313 1.71582 14.5406V16.875C1.71582 17.2125 1.99707 17.5219 2.3627 17.5219C2.72832 17.5219 3.00957 17.2407 3.00957 16.875V14.5406C3.00957 12.2344 4.89394 10.3219 7.22832 10.3219H10.8564C13.1627 10.3219 15.0752 12.2063 15.0752 14.5406V16.875C15.0752 17.2125 15.3564 17.5219 15.7221 17.5219C16.0877 17.5219 16.3689 17.2407 16.3689 16.875V14.5406C16.2846 11.5313 13.8377 9.05627 10.8283 9.05627Z"-->
<!--									fill="" />-->
<!--							</svg>-->
<!--						</div>-->
<!--						<div class="ml-2">-->
<!--							User Impersonation-->
<!--						</div>-->
<!--					</a>-->
<!--				</li>-->
				<li class="hover:cursor-pointer">
					<DashboardHeaderOrgDropdown :inlineLabelIcon=true
								 inlineLabel="My Organizations"
								 :items="organizationData"
								 itemClass="text-primary-hover"
								 v-model="currentOrg"
								 @onItemSelected="onOrganizationClicked"
								 :showSelectedOutline="false"
								 :showSelectedCheckmark="false"
								 :showOptionsOverContent="false"
								 :wrapItemText = "true">
						<template v-slot:inline-label-icon>
							<!-- Icon shown next to "My Organizations" -->
							<svg width="22" height="22" viewBox="0 0 20 20" fill="current" xmlns="http://www.w3.org/2000/svg">
								<title>My Organizations</title>
								<path d="M17.9062 5.09375H15.125V4.5625C15.125 3.90625 14.6562 3.375 14.0625 3.25V1.875C14.0625 1.15625 13.4688 0.53125 12.7188 0.53125H7.25C6.53125 0.5625 5.9375 1.15625 5.9375 1.875V3.25C5.3125 3.375 4.875 3.90625 4.875 4.5625V5.09375H2.09375C1.25 5.09375 0.5625 5.78125 0.5625 6.625V17.5312C0.5625 18.5938 1.40625 19.4375 2.46875 19.4375H17.5625C18.625 19.4375 19.4688 18.5938 19.4688 17.5312V6.625C19.4688 5.78125 18.7812 5.09375 17.9062 5.09375ZM7.34375 1.96875H12.6875V3.21875H7.34375V1.96875ZM1.96875 17.5312V6.625C1.96875 6.5625 2.03125 6.5 2.09375 6.5H4.875V18.0625H2.46875C2.1875 18.0625 1.96875 17.8125 1.96875 17.5312ZM10.4062 18.0625H9.59375H9.3125V14.0312H10.7188V18.0312H10.4062V18.0625ZM12.125 18.0625V13.3438C12.125 12.9688 11.8125 12.625 11.4062 12.625H8.59375C8.21875 12.625 7.875 12.9375 7.875 13.3438V18.0625H6.25V4.625H13.75V18.0625H12.125ZM18.0625 17.5312C18.0625 17.8125 17.8438 18.0312 17.5625 18.0312H15.1562V6.46875H17.9375C18 6.46875 18.0625 6.53125 18.0625 6.59375V17.5312Z"/>
								<path d="M11.375 7.15613H10.6875V6.46863C10.6875 6.09363 10.375 5.74988 9.96875 5.74988C9.59375 5.74988 9.25 6.06238 9.25 6.46863V7.15613H8.5625C8.1875 7.15613 7.84375 7.46863 7.84375 7.87488C7.84375 8.28113 8.15625 8.59363 8.5625 8.59363H9.25V9.28113C9.25 9.65613 9.5625 9.99988 9.96875 9.99988C10.3437 9.99988 10.6875 9.68738 10.6875 9.28113V8.59363H11.375C11.75 8.59363 12.0938 8.28113 12.0938 7.87488C12.0938 7.46863 11.7813 7.15613 11.375 7.15613Z"/>
							</svg>
						</template>
<!--						<template v-slot:item-icon>-->
<!--							&lt;!&ndash; (+) next to Add (/src/assets/images/icon/plus_w_circle_black.svg) &ndash;&gt;-->
<!--							<svg xmlns="http://www.w3.org/2000/svg"  class="h-4 w-4 stroke-primary-hover " viewBox="0 0 23 24">-->
<!--								<path fill="#00539B" d="M15.325 11.137h-3V8.175c0-.45-.375-.825-.862-.825-.45 0-.825.375-.825.862v2.963H7.675c-.45 0-.825.375-.825.862 0 .45.375.825.863.825h2.962v2.963c0 .45.375.825.863.825.45 0 .825-.375.825-.863v-2.962h2.962c.45 0 .825-.375.825-.863a.83.83 0 0 0-.825-.825"/>-->
<!--								<path fill="#00539B" d="M11.5.675A11.315 11.315 0 0 0 .175 12c0 6.262 5.1 11.362 11.362 11.362S22.9 18.262 22.9 12C22.863 5.737 17.763.675 11.5.675m0 21c-5.325 0-9.637-4.35-9.637-9.675A9.634 9.634 0 0 1 11.5 2.362c5.325 0 9.675 4.313 9.675 9.638s-4.35 9.675-9.675 9.675"/></svg>-->
<!--						</template>-->
					</DashboardHeaderOrgDropdown>
				</li>
				<!--AJL (01/05/26) - Removed until implementation decided
				<li>
					<a href="#" @click.prevent="showAddOrganizationModal"
						 class="flex items-center gap-3.5 font-medium duration-300 ease-in-out hover:text-primary-hover lg:text-base">
						<div class="h-6 w-6 pl-2">
							<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6">
								<path stroke-linecap="round" stroke-linejoin="round" d="M12 9v6m3-3H9m12 0a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
							</svg>
						</div>
						<div class="ml-2">
							Join Organization
						</div>
					</a>
				</li>-->
				<li class="divider"/>
				<li>
					<a href="#" @click.prevent="$emit('contactUsClicked'); dropdownOpen = false"
						 class="flex items-center gap-3.5 font-medium duration-300 ease-in-out hover:text-primary-hover lg:text-base"
					>
						<div class="pl-2">
							<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6">
								<title>Contact Us</title>
								<path stroke-linecap="round" stroke-linejoin="round" d="M21.75 6.75v10.5a2.25 2.25 0 0 1-2.25 2.25h-15a2.25 2.25 0 0 1-2.25-2.25V6.75m19.5 0A2.25 2.25 0 0 0 19.5 4.5h-15a2.25 2.25 0 0 0-2.25 2.25m19.5 0v.243a2.25 2.25 0 0 1-1.07 1.916l-7.5 4.615a2.25 2.25 0 0 1-2.36 0L3.32 8.91a2.25 2.25 0 0 1-1.07-1.916V6.75" />
							</svg>
						</div>
						Contact Us
					</a>
				</li>
				<li class="divider"/>
				<li>
					<a href="#" @click.prevent="logout"
						 class="flex items-center gap-3.5 font-medium duration-300 ease-in-out hover:text-primary-hover lg:text-base"
					>
						<div class="pl-2">
							<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6">
								<title>Log Out</title>
								<path stroke-linecap="round" stroke-linejoin="round" d="M10.5 19.5 3 12m0 0 7.5-7.5M3 12h18" />
							</svg>
						</div>
						Log Out
					</a>
				</li>
			</ul>
		</div>
		<!-- Dropdown End -->
	</div>

	<Teleport to="html">
		<MultiButtonModal
			:show="orgStore.getSwitchOrganizationToId > 0"
			icon="info"
			title="Switch Organization"
			:message="`Are you sure you want to switch the active organization to <b>${getOrganizationToSwitchToName()}</b>?`"
			:buttons="[
									new ModalButtonData(
										'Cancel', () => { orgStore.setSwitchOrganizationToId(0) }, ButtonType.Outline, ButtonSize.Small
									),
									new ModalButtonData(
										'Switch', () => { changeOrganizations() }, ButtonType.Default, ButtonSize.Small
									)
								]"
		/>
	</Teleport>
</template>

<script setup lang="js">
import { computed, ref } from 'vue'
import { useAuthStore } from '@/stores/authStore.js'
import { useOrganizationStore } from '@/stores/organizationStore.js'
import DashboardHeaderOrgDropdown from '@/components/Dashboard/Header/DashboardHeaderOrgDropdown.vue'
import MultiButtonModal from '@/components/Alerts/MultiButtonModal.vue'
import { ModalButtonData } from '@/components/Alerts/ModalButtonData.js'
import { ButtonSize, ButtonType } from '@/components/Forms/Buttons/SubmitButtonConstants.js'

const authStore = useAuthStore()
const orgStore = useOrganizationStore()

const target = ref(null)
const dropdownOpen = ref(false)

defineEmits(['contactUsClicked']);

const userName = computed(() =>
{
	return (authStore.getAuth?.user()?.given_name ?? '?') + ' ' + (authStore.getAuth?.user()?.family_name ?? '?')
})

const userOrganizationNameAndRole = computed(() => {
	const org = authStore.getActiveOrganization
	return org ? (org.use_dba ? org.organization_name_dba : org.organization_name) + ' / ' + org.user_role : ''
})

const userOrganizationNameTooltipText = computed(() => {
	const org = authStore.getActiveOrganization
	return org ? (org.organization_name + '<br>(' + org.organization_name_dba + ')') : ''
})

/**
 * Get the user's initials (computed if they change their name in their settings)
 * @vue-computed {string}
 */
const userInitials = computed(() => {
	const first_name = authStore.getAuth?.user()?.given_name
	const last_name = authStore.getAuth?.user()?.family_name

	let first_init = '', last_init = ''
	if (first_name && first_name.length > 0)
	{
		first_init = first_name[0]
	}
	if (last_name && last_name.length > 0)
	{
		last_init = last_name[0]
	}

	return first_init + last_init;
})

/**
 * User organization data loaded into data object for the ListBox
 * @vue-computed {Array<Organization>} Array of active organizations
 */
const organizationData = computed(() =>
{
	let organizations = [];
	try
	{
		const org_data = authStore.userOrganizations.filter((org) => org.deleted_at === null && org.user_organization_deleted_at === null) //Remove deactivated orgs

		if (org_data)
		{
			organizations = org_data.map((p_org) =>
			{
				const org_role = authStore.isDeveloper ? " " + p_org.user_role : "";
				const org_text = p_org.organization_name + (p_org.organization_name_dba ? " (" + p_org.organization_name_dba + ")" : "")
				return { 'id': p_org.id, 'text': org_text, 'disabled': false, action: 'change_organization', class: '', org_role: org_role };
			})
		}

		// organizations.push({ id: 0, text: 'Add New Organization', disabled: false, itemIcon: true, action: 'add_organization', class: '' })
	}
	catch(e)
	{
		console.error("organizationData", e)
	}

	return organizations;
})

/**
 * Current organization record in user's orgs based on the user's active org
 * @vue-computed {Organization|null|}
 */
const currentOrg = computed(() =>{
	try
	{
		if (organizationData.value)
		{
			for (let i = 0; i < organizationData.value.length; i++)
			{
				if (organizationData.value[i].id === authStore.activeOrganizationId)
				{
					return organizationData.value[i];
				}
			}
		}
	}
	catch(e){
		console.error("currentOrg", e);
	}

	return null;
})

/**
 * Show the Add Organization Modal
 */
function showAddOrganizationModal()
{
	orgStore.showAddOrgToUserModal(true)
	dropdownOpen.value = false
}

/*
 * Allow admin to impersonate another user for testing/debugging
 */
/*function userImpersonation()
{
	// TODO: implement
	alert('impersonate')
	router.push({ name: 'auth.select-organization' })
}*/

/**
 * Logout user
 */
function logout()
{
	authStore.logout()
}

/**
 * Called when user selects an organization in the ListBox
 * @param p_item
 */
function onOrganizationClicked(p_item)
{
	if (p_item.action === 'change_organization')
	{
		if (authStore.activeOrganizationId !== p_item.id)
		{
			orgStore.setSwitchOrganizationToId(p_item.id)
		}
	}
	else if (p_item.action === 'add_organization')
	{
		showAddOrganizationModal()
	}
}

function changeOrganizations()
{
	const activeOrgId = getOrganizationToSwitchTo().id
	authStore.setActiveOrganizationId(activeOrgId)//authStore.userOrganizationData.activeOrganizationId = activeOrgId

	// Move the active org to the top
	const organizations = authStore.userOrganizations
	const activeOrg = organizations.find(org => org.id === activeOrgId)
	const otherOrgs = organizations.filter(org => org.id !== activeOrgId).sort(function(a, b)
	{
		return a.organization_name.localeCompare(b.organization_name)
	})

	authStore.setUserOrganizations([activeOrg, ...otherOrgs])
	orgStore.setSwitchOrganizationToId(0)
	doReload()
}

function getOrganizationToSwitchTo()
{
	if (authStore.userOrganizations.length > 0)
	{
		return authStore.userOrganizations.find(organization => organization.id === orgStore.getSwitchOrganizationToId)
	}

	return null
}

/**
 * Gets the name of the organization user selected to switch to. Used to prevent "undefined" appearing as page switches b/c the dialog doesn't hide fast enough
 * @returns {string}
 */
function getOrganizationToSwitchToName()
{
	const name = getOrganizationToSwitchTo()?.organization_name?.trim();
	if (name) return name;
	return "";
}

function doReload()
{
	location.reload()
}

</script>

<style scoped>
	.divider {
		background: #B2BBC9;
		height: 1px;
	}
</style>